import React from "react"
import { FaShoppingCart, FaCog, FaRegListAlt, FaSearch } from "react-icons/fa"
import { PiPrinter } from "react-icons/pi"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useHistory } from "react-router-dom"
import { MdHome } from "react-icons/md"

import { toggleFoodSearchBar, toggleFoodSidebar } from "@redux"
import { haveAuth } from "utils"
import { IconButton } from "components"
import classes from "./PcFooter.module.scss"

const PcFooter = () => {
  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const order = useSelector(state => state.order)

  const notViewedOrders =
    useSelector(state => state.notViewedOrders.notViewedOrders)

  const totalFailedPrints =
    useSelector(state => state.failedPrints.length)

  const notViewedOfflineOrders =
    useSelector(state =>
      state.offlineOrders.filter(o => !o.isViewed).length
    )

  const handleToggleFoodSearch = () => {
    dispatch(
      toggleFoodSearchBar()
    )
  }

  const handleToggleFoodSidebar = () => {
    dispatch(
      toggleFoodSidebar()
    )
  }

  const handleNavigate = () => {
    history.push("/failed-printers")
  }

  const showsOrdersIcon =
    haveAuth([
      "viewOrderHistory",
      "viewUnconfirmedOrders",
      "viewLatestOrders"
    ],
      "needOneOfAccesses"
    )

  const totalNotViewedOrders =
    notViewedOrders.pending +
    notViewedOrders.paid +
    notViewedOrders.canceled +
    notViewedOfflineOrders

  const showFailedPrintIcon =
    totalFailedPrints !== 0 &&
    haveAuth(["printerAccess"])

  const numberOfOrderItems =
    order.items.reduce((to, item) =>
      to += !item.isExtra ? item.quantity : 0
      , 0
    )

  const numberOfComboItems =
    order.combos.reduce((t, combo) =>
      t += combo.items.reduce((to, item) =>
        to += item.quantity
        , 0
      )
      , 0
    )

  const totalItems =
    numberOfOrderItems + numberOfComboItems

  return (
    <div className={classes["footer"]}>
      {location.pathname === "/foods"
        ?
        <IconButton
          icon={FaSearch}
          color="white"
          className={classes["icon"]}
          size={30}
          onClick={handleToggleFoodSearch}
        />
        :
        <IconButton
          icon={MdHome}
          color="white"
          className={classes["icon"]}
          size={30}
          onClick={() => history.push("/foods")}
        />
      }
      <IconButton
        icon={FaShoppingCart}
        color="white"
        badge={totalItems}
        className={classes["icon"]}
        size={30}
        onClick={handleToggleFoodSidebar}
      />
      <IconButton
        disabled={!showFailedPrintIcon}
        icon={PiPrinter}
        color="white"
        className={classes["icon"]}
        badge={totalFailedPrints}
        size={30}
        onClick={handleNavigate}
      />

      {
        showsOrdersIcon &&
        <IconButton
          icon={FaRegListAlt}
          color="white"
          size={30}
          className={classes["icon"]}
          badge={totalNotViewedOrders}
          onClick={() => history.push("/orders")}
        />
      }
      <IconButton
        icon={FaCog}
        color="white"
        size={30}
        className={classes["icon"]}
        onClick={() => history.push("/settings")}
      />
    </div>
  )
}

export default PcFooter